import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local';

// Determine language from URL
const pathname = window.location.pathname;
const getInitialLanguage = () => {
  if (pathname.startsWith('/ru')) return 'ru';
  if (pathname.startsWith('/us')) return 'us';
  if (pathname.startsWith('/en')) return 'en';
  return 'tr';
};

i18n
  .use(initReactI18next)
  .init({
    resources: messages,
    lng: getInitialLanguage(),
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
